import type { updateUserPasswordBodyZod } from "@nlc/shared-types";
import type { z } from "zod";

import { useMutation } from "@tanstack/react-query";

import apiClient from "@/lib/api/client";

export function useUpdateUserPasswordMutation() {
  return useMutation({
    mutationFn: async ({
      confirmPassword,
      password,
      userId,
    }: z.infer<typeof updateUserPasswordBodyZod>) =>
      await apiClient
        .url("/users/update-user-password")
        .post({ confirmPassword, password, userId })
        .json(),
    mutationKey: ["update-password"],
  });
}
